import { type ApiError, createApiClient } from '@dataroom/api-client';
import { previewFetch } from './preview-header';

/** Called when the API answers 401; the router installs a redirect to /login. */
let onUnauthenticated: ((err: ApiError) => void) | null = null;

export function setUnauthenticatedHandler(fn: (err: ApiError) => void): void {
  onUnauthenticated = fn;
}

/**
 * The app-wide API client (same origin `/api/v1`; Vite proxies to the API in dev).
 *
 * Typed contracts (plan §4.9): `api.call(navContract)`, `api.call(contract, { params, query, body })`
 * with contracts from `@dataroom/contracts/<area>`. Endpoint groups that predate contracts:
 * `import { workflowsApi } from '@dataroom/api-client/workflows'; workflowsApi(api.http)`.
 */
export const api = createApiClient({
  onUnauthenticated: (err) => onUnauthenticated?.(err),
  // A planned change shown in the app is read from the server's preview of it (lib/preview-header.ts).
  fetch: previewFetch,
});
export type Api = typeof api;
